import { render, staticRenderFns } from "./SecretModal.vue?vue&type=template&id=4d8b6524&scoped=true&"
import script from "./SecretModal.vue?vue&type=script&lang=js&"
export * from "./SecretModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b6524",
  null
  
)

export default component.exports